export { default as Shop } from './containers/ShopContainer'



// WEBPACK FOOTER //
// ./src/Shop/index.js